export default __webpack_public_path__ + "static/media/colors-480w.158e7372.avif";